document.addEventListener('click', function (event) {
  const swatch = event.target.closest('.card-variant-swatch');

  if (!swatch) return;

  event.preventDefault();
  event.stopPropagation();

  const cardWrapper = swatch.closest('.card-wrapper');

  if (!cardWrapper) return;

  const primaryImage = cardWrapper.querySelector(
    '.card__media .media > img:first-child'
  );

  const imageSrc = swatch.dataset.imageSrc;
  const imageAlt = swatch.dataset.imageAlt;
  const variantUrl = swatch.dataset.variantUrl;

  cardWrapper
    .querySelectorAll('.card-variant-swatch')
    .forEach(function (button) {
      button.classList.remove('is-selected');
      button.setAttribute('aria-pressed', 'false');
    });

  swatch.classList.add('is-selected');
  swatch.setAttribute('aria-pressed', 'true');

  if (primaryImage && imageSrc) {
    cardWrapper.classList.add('card-swatch-image-selected');

    const imagePreloader = new Image();

    imagePreloader.onload = function () {
      primaryImage.removeAttribute('srcset');
      primaryImage.removeAttribute('sizes');

      primaryImage.setAttribute('src', imageSrc);
      primaryImage.setAttribute('srcset', imageSrc);

      if (imageAlt) {
        primaryImage.setAttribute('alt', imageAlt);
      }

      primaryImage.style.opacity = '1';

      void primaryImage.offsetWidth;
    };

    imagePreloader.src = imageSrc;

    if (imagePreloader.complete) {
      imagePreloader.onload();
    }
  }

  if (variantUrl) {
    cardWrapper
      .querySelectorAll('a.full-unstyled-link, a.product__view-details')
      .forEach(function (link) {
        link.href = variantUrl;
      });

    cardWrapper
      .querySelectorAll('[data-product-url]')
      .forEach(function (element) {
        element.setAttribute('data-product-url', variantUrl);
      });
  }
});